import { Translation } from "./hooks/useTranslations";

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const formatDate = (value: string, locale?: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return new Date(value).toLocaleDateString(locale, options);
};

export const formatTimeStamp = (value: string, locale?: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  return new Date(value).toLocaleDateString(locale, options);
};

export const formatBoolean = (translations: Translation, value?: boolean): string =>
  value ? translations.common.yes : translations.common.no;

export const formatCurrency = (value: number, currency: string, language: string): string =>
  new Intl.NumberFormat(language, {
    style: "currency",
    currency: currency,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(value ?? 0);

const numberFormat = new Intl.NumberFormat(undefined, {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
export const formatWeight = (value: number, unitOfMeasurement: "kg" | "lb"): string =>
  `${numberFormat.format((value ?? 0) / (unitOfMeasurement === "lb" ? 2.2046 : 1))} ${unitOfMeasurement}`;

export const generateSecret = (length: number) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmopqrstuvwxyz0123456789!()_=";
  let result = "";
  let counter = 0;
  while (counter < length) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
    counter++;
  }
  return result;
};

export const chunkArray = <T>(arr: T[], size: number) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) => arr.slice(i * size, i * size + size));

// returns a timestamp rounded down to the minute
export const getMinutesRoundedTimestamp = (): number => {
  const now = new Date();
  now.setSeconds(0, 0); // Set seconds and milliseconds to 0
  return Math.floor(now.getTime() / 1000); // Get UNIX timestamp in seconds
};

export const areArraysEqual = <T extends string | number>(a: T[], b: T[]): boolean =>
  a.length === b.length && a.every((val, i) => val === b[i]);

export const itemLabel = (item?: { name?: string | null; description?: string | null; code?: string | null }) =>
  item?.code || item?.description || item?.name || "";
